var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcFooterViewed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M10.143 15.975a5.857 5.857 0 1 1 11.714 0 5.857 5.857 0 0 1-11.714 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16 6.5c-3.662 0-7.028 1.35-9.675 3.61a.5.5 0 1 1-.65-.761C8.494 6.944 12.087 5.5 16 5.5s7.506 1.444 10.324 3.849a.5.5 0 1 1-.65.76C23.028 7.85 19.662 6.5 16 6.5M5.62 21.896a.5.5 0 0 1 .705-.056c2.648 2.26 6.013 3.61 9.675 3.61s7.028-1.35 9.675-3.61a.5.5 0 1 1 .65.76c-2.817 2.406-6.41 3.85-10.325 3.85S8.493 25.006 5.675 22.6a.5.5 0 0 1-.055-.704",
  clipRule: "evenodd"
})));
export default SvgIcFooterViewed;